var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Label, SpinnerIcon, translate, } from '@lucidlink/uicore';
export const StatusTextInProgress = ({ 'data-testid': testId, }) => {
    return (_jsx(Label, { color: 'static_info', "data-testid": testId, StartIcon: SpinnerIcon, text: translate('In progress') }));
};
_react_refresh_temp_1 = StatusTextInProgress;
$RefreshReg$(_react_refresh_temp_1, "StatusTextInProgress");
